
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { NetezzaLinkedService } from 'app/model/linkedservice/netezza.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.netezza.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Netezza_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Netezza_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: NetezzaLinkedService.MODEL // Linked service redefined
        }
    }
})
export class NetezzaTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
